<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        
        <div
            v-if="loading"
            key="isLoading"
            class="min-height-200"
            style="height: 200px;"
        >
            <busy-spinner></busy-spinner>
        </div>

        <workflow-run-list
            v-show="showList"
            key="hasListItems"
            :show-fields="['title', 'status', 'active_tasks', 'created', 'modified']"
            :show-filters="[]"
            :preset-filters="{status: 'active'}"
            endpoint-path="workflowRun.get_list_external"
            spec-group-slugs="_quality_module"
            initial-sort-field="modified"
            initial-sort-desc
            item-name="Quality Issue"
            item-name-plural="Quality Issues"
            @list-loaded="handleListLoaded"
            @list-loading="handleListLoading"
        ></workflow-run-list>  <!-- :show-filters="['status']" -->

        <div 
            v-if="showEmpty"
            key="emptyList"
            class="w-100"
        >
            <div class="p-4 text-muted text-center border rounded-lg" style="background-color: rgba(255,255,255,0.3)">
                <div>
                    You have no active Quality Issues right now.
                </div>
                <div class="mt-4">
                    <b-icon icon="inbox" font-scale="4" class="text-secondary-lighter"></b-icon>
                </div>
            </div>
            
        </div>

    </div>
</template>

<script>
import { errorHandling } from '../../js/custom-vue-mixins';

// this is a wrapper around the WorkflowRunList
// to show better empty state and maybe other things

export default {
    name: 'PortalWorkflowRunList',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            itemCount: null,  // update once you get loaded event from list component
        }
    },
    computed: {
        showList() {
            // should we show the list?  
            return !this.loading && !!this.itemCount;
        },
        showEmpty() {
            // should we show the empty thing instead?
            return !this.loading && !this.showList;
        },
    },
    mounted() {
        
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        handleListLoaded(itemCount) {
            // handle the 'list-loaded' event from list component
            // payload will be count of ALL records, even if paginated
            // don't do anything with them here... just need them for getting count
            this.itemCount = itemCount;
            this.loading = false;
        },
        handleListLoading() {
            // handle the 'list-loading' event from list component, meaning it has started loading
            // no payload
            this.loading = true;
        },
    }
}
</script>

<style>

</style>